import { render, staticRenderFns } from "./RegistrationSurvey.vue?vue&type=template&id=4b2f8fab&"
import script from "./RegistrationSurvey.vue?vue&type=script&lang=js&"
export * from "./RegistrationSurvey.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSurvey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports